var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66309 10.8584H23.3418C23.4234 10.8584 23.5018 10.8915 23.5596 10.9492C23.6172 11.007 23.6494 11.0854 23.6494 11.167V20.833C23.6494 20.9146 23.6172 20.993 23.5596 21.0508C23.5018 21.1085 23.4234 21.1416 23.3418 21.1416H8.66309C8.58142 21.1416 8.50307 21.1085 8.44531 21.0508C8.38755 20.993 8.3545 20.9147 8.35449 20.833V11.167C8.3545 11.0853 8.38755 11.007 8.44531 10.9492C8.50308 10.8915 8.5814 10.8584 8.66309 10.8584ZM22.9521 11.8721L16.1943 17.3086C16.1397 17.3523 16.0719 17.377 16.002 17.377C15.932 17.3769 15.8641 17.3523 15.8096 17.3086H15.8086L9.05176 11.8721L8.9707 11.8066V20.5254H23.0332V11.8066L22.9521 11.8721ZM9.64941 11.5635L15.9707 16.6543L16.002 16.6797L16.0332 16.6543L22.3545 11.5635L22.4658 11.4746H9.53906L9.64941 11.5635Z",
    fill: "#0F2A59",
    stroke: "#0F2A59",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailNew);
export default __webpack_public_path__ + "static/media/mail-new.6c4cd3031653c5e4f736083d584ef5bd.svg";
export { ForwardRef as ReactComponent };